import {
  useBookingMutation as useBookingMutationNew,
  useResetAccountMutation as useResetAccountMutationNew,
} from "./use-api";

// Re-export the new hooks for backward compatibility
export {
  useBookingMutationNew as useBookingMutation,
  useResetAccountMutationNew as useResetAccountMutation,
};
